//====================================================
//  Function: Textarea resize
//====================================================
function fn_components_textareaResize(){
	if ($('textarea[data-autoresize]').length){
		autosize($('textarea[data-autoresize]'));
	}
}
